<div
  [formGroup]="form"
  class="d-grid gap-3"
  [style.gridTemplateColumns]="modalityEnabled ? '1fr 1fr 1fr 1fr 40px' : '1fr 1fr 1fr 40px'"
>
  <div>
    <mat-form-field2 class="mat-block" matAutocompleteOrigin #origin="matAutocompleteOrigin">
      <input
        type="text"
        formControlName="name"
        matInput
        [matAutocomplete]="auto"
        [matAutocompleteConnectedTo]="origin"
        required
        placeholder="Tax Name:"
        i18n-placeholder
      />
      <mat-autocomplete #auto="matAutocomplete">
        <mat-option *ngFor="let tax of filteredTaxes$ | async" [value]="tax.name">
          {{ tax.name }}
        </mat-option>
      </mat-autocomplete>
      <mat-error *ngIf="form.get('name').touched && form.get('name').hasError('required')">
        <ng-container i18n>Tax name is required</ng-container>
      </mat-error>
      <mat-error *ngIf="form.get('name').touched && form.get('name').hasError('minlength')">
        <ng-container i18n>Tax name must be at least 2 characters long</ng-container>
      </mat-error>
      <mat-error *ngIf="form.get('name').touched && form.get('name').hasError('maxlength')">
        <ng-container i18n>Tax name must be at most 50 characters long</ng-container>
      </mat-error>
    </mat-form-field2>
  </div>
  <div>
    <mat-form-field2 class="mat-block">
      <mat-label>
        <span [innerHtml]="form.get('type').value | amountPlaceholder : '$'"></span>
      </mat-label>
      <input type="number" min="0" formControlName="amount" required matInput decimal />
      <mat-error *ngIf="form.get('amount').touched && form.get('amount').hasError('required')">
        <ng-container i18n>Amount is required</ng-container>
      </mat-error>
      <mat-error *ngIf="form.get('amount').touched && form.get('amount').hasError('percent')">
        <ng-container i18n>Amount should be at least 0 and less than 100</ng-container>
      </mat-error>
      <mat-error *ngIf="form.get('amount').touched && form.get('amount').hasError('minNumber')">
        <ng-container i18n>Amount must be at least 0</ng-container>
      </mat-error>
    </mat-form-field2>
  </div>
  <div>
    <mat-form-field2 class="mat-block">
      <mat-select formControlName="type" placeholder="Type" i18n-placeholder>
        <mat-option value="percent" i18n>Percent</mat-option>
        <mat-option value="flat" i18n>Flat</mat-option>
      </mat-select>
    </mat-form-field2>
  </div>
  <div *ngIf="modalityEnabled">
    <mat-form-field2 class="mat-block">
      <mat-select formControlName="modality" placeholder="Modality" i18n-placeholder>
        <mat-option [value]="taxV3Modalities.PerStay">{{ taxV3ModalityLabels[taxV3Modalities.PerStay] }}</mat-option>
        <mat-option [value]="taxV3Modalities.PerNight">{{ taxV3ModalityLabels[taxV3Modalities.PerNight] }}</mat-option>
        <mat-option [value]="taxV3Modalities.PerPerson">{{
          taxV3ModalityLabels[taxV3Modalities.PerPerson]
        }}</mat-option>
        <mat-option [value]="taxV3Modalities.PerPersonPerNight">{{
          taxV3ModalityLabels[taxV3Modalities.PerPersonPerNight]
        }}</mat-option>
      </mat-select>
    </mat-form-field2>
  </div>
  <button (click)="remove.emit(index)" class="btn btn-secondary-danger align-input-row-end" type="button">
    <i class="cs-icon cs-icon-trash"></i>
  </button>
</div>
